export enum ENVIRONMENT {
  LOCAL = 'development',
  DEV = 'dev',
  STAGING = 'staging',
  SANDBOX = 'sandbox',
  PRODUCTION = 'production',
}
